import { OverlayRef } from '@angular/cdk/overlay'
import { Observable, Subject } from 'rxjs'

/**
 * A reference to the dialog itself.
 * Can be injected into the component added to the overlay and then used to close itself.
 */
export class DialogRef<T = unknown> {
  private afterClosedSubject = new Subject<T>()

  constructor(private overlayRef: OverlayRef) {
    document.body.style.overflowY = 'hidden'
  }

  /**
   * Closes the overlay. You can optionally provide a result.
   */
  public close(result?: T): void {
    document.body.style.overflowY = 'initial'
    this.overlayRef.dispose()
    this.afterClosedSubject.next(result as T)
    this.afterClosedSubject.complete()
  }

  /**
   * An Observable that notifies when the overlay has closed
   */
  public afterClosed(): Observable<T> {
    return this.afterClosedSubject.asObservable()
  }
}
